import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export const RadioOptions = ({ handleChange, value, options, disabled }) => (
    <RadioGroup
        value={value}
        onChange={change => handleChange(change.target.value)}
    >
        {options &&
            options.map(({ name, value }) => (
                <FormControlLabel
                    disabled={disabled}
                    key={value}
                    value={value}
                    control={<Radio />}
                    label={name}
                />
            ))}
    </RadioGroup>
);
